/* eslint-disable no-param-reassign */
import produce from 'immer';

import { REASON_CODE_DICTIONARY } from './constants';

/**
 *
 * @param {array} reasons  An array of reason codes or an error code
 * @param {object} defaultErrors The default error values
 */
export const parseReasonCodes = (reasons, defaultErrors) => {
  const { additionalPrincipal } = produce(defaultErrors, (draft) => {
    reasons.forEach((reasonCode) => {
      if (REASON_CODE_DICTIONARY[reasonCode]) {
        const { key, message } = REASON_CODE_DICTIONARY[reasonCode];
        draft[key] = message;
      }
    });
  });
  return { flexDraft: { amount: { additionalPrincipal } } };
};
